function EditorArtiCleCpn({data}){

    const {title="",image="",desc="",category="",date=""} = data || {};

    return (
        <>
            <a href="/analysis/top-crypto-narratives-of-2025/">
                <div className="EditorsPicks_cardDiv__ihA5m">
                    <div className="EditorsPicks_upperDiv__5hQyE">
                    <div className="EditorsPicks_thumbnailDiv___F2th">
                        <img
                        alt="Top Crypto Narratives to Watch Out in 2025"
                        loading="lazy"
                        width={1024}
                        height={576}
                        decoding="async"
                        data-nimg={1}
                        className="EditorsPicks_thumbnail__VtDaN"
                        src={image}
                        style={{
                            color: "transparent",
                            maxWidth: "100%",
                            height: "auto"
                        }}
                        />
                    </div>
                    <div className="EditorsPicks_detailsDiv__For3S">
                        <div className="EditorsPicks_categoryDiv__1CZ6b">{category}</div>
                        <div className="EditorsPicks_titleDiv__QA7DT">
                        {title}
                        </div>
                        <div className="EditorsPicks_descriptionDiv__Dl_KL">
                       
                        {desc}
                        </div>
                    </div>
                    </div>
                    <div className="EditorsPicks_lowerDiv__XriF_">
                    <div className="EditorsPicks_dateDiv__eNGcB">{date}</div>
                    </div>
                </div>
            </a>
        </>
    )
}

export default EditorArtiCleCpn;